// import {useRef} from  "react"
// import { Controller } from 'react-hook-form';
// import useSearch from '../hooks/useSearch';
// import FormInputField from '../../common/components/formElements/FormInputField';
// import FormDatePicker from '../../common/components/formElements/FormDatePicker';
// import FormComboBox from '../../common/components/formElements/FormComboBox';
// import { Link, useSearchParams } from 'react-router-dom';
// import imgsearch from './../../images/serch-icon.png';
// import { useEffect, useState } from 'react';
// import Select from 'react-select';
// import useSearchResults from '../../searchResults/hooks/useSearchResults';
// import axios from 'axios';

// const auxDate = new Date();
// const MIN_DATE = new Date(auxDate.setDate(auxDate.getDate() + 1));
// const API_BASE_URL = process.env.REACT_APP_API_SERVER;

// export default function Search() {
//     const specialtyRef = useRef(null); // 👈 f
//     const insuranceRefs = useRef(null);
//     const [searchParams] = useSearchParams();
//     const {
//         onSearch,
//         register,
//         handleSubmit,
//         control,
//         formError,
//         cities,
//         error,
//         getValues,
//         reset
//     } = useSearch();
//     const { getCurrentSearchParams } = useSearchResults();
//     const [specialities, setSpecialities] = useState([]);
//     const [insurances, setInsurances] = useState([]);
//     const handleSpecialtyClick = () => {
//         if (specialtyRef.current) {
//             specialtyRef.current.focus(); // 👈 triggers dropdown open
//         }
//     };
//     const handleInsuranceClick = () => {
//         if (insuranceRefs.current) {
//             insuranceRefs.current.focus(); // 👈 triggers dropdown open
//         }
//     }
//     useEffect(() => {
//         const { date, city, q,doctorName,insurance } = getCurrentSearchParams();
//         const selectCity = cities.find((item) => item.id.toString() === city);
//         reset({ specialty: q, city: selectCity, doctorName ,insurance });
//     }, [searchParams, cities]);

//     const getData = async () => {
//         try {
//           const [specialtyRes, insuranceRes] = await Promise.allSettled([
//             axios.get(`${API_BASE_URL}/specialty/getList`),
//             axios.get(`${API_BASE_URL}/insurance/getList`)
//           ]);

//           if (specialtyRes.status === "fulfilled") {
//             const formattedSpecialties = specialtyRes.value.data.map((item) => ({
//               value: item.id,
//               label: item.name
//             }));
//             setSpecialities(formattedSpecialties);
//           } else {
//             console.warn("Failed to fetch specialties:", specialtyRes.reason);
//           }

//           if (insuranceRes.status === "fulfilled") {
//             const formattedInsurance = insuranceRes.value.data.map((item) => ({
//               value: item.id,
//               label: item.name
//             }));
//             setInsurances(formattedInsurance);
//           } else {
//             console.warn("Failed to fetch insurance:", insuranceRes.reason);
//           }

//         } catch (error) {
//           console.error("Unexpected error:", error);
//         }
//       };

//     useEffect(() => {
//         getData();
//     }, []);

//     const customStyles = {
//         control: (styles, state) => ({
//           ...styles,
//           backgroundColor: 'transparent',
//           border: 'none',
//           boxShadow: 'none',
//           outline: 'none',
//           borderRadius: '8px',
//           '&:hover': {
//             border: 'none',
//           },
//         }),
//         option: (styles, { isDisabled, isFocused, isSelected }) => {
//           let backgroundColor = 'white';
//           let color = 'black';

//           if (isDisabled) {
//             backgroundColor = '#f0f0f0';
//             color = '#999';
//           } else if (isSelected) {
//             backgroundColor = '#3182ce';
//             color = 'white';
//           } else if (isFocused) {
//             backgroundColor = '#ebf8ff';
//             color = '#2b6cb0';
//           }

//           return {
//             ...styles,
//             backgroundColor,
//             color,
//             cursor: isDisabled ? 'not-allowed' : 'pointer',
//           };
//         },
//         indicatorSeparator: () => ({
//           display: 'none',
//         }),
//         dropdownIndicator: (styles) => ({
//           ...styles,
//           color: '#888',
//         }),
//         menu: (styles) => ({
//           ...styles,
//           zIndex: 9999,
//         }),
//       };

//     return (
//         <div className="bg-dl-screen-lightblue lg:px-8 mx-auto px-4 relative sm:px-6">
//             <div className="grid grid-cols-12 gap-12">
//                 <div className="col-span-12 md:col-span-12 search-box-top-main">
//                     <form onSubmit={handleSubmit(onSearch)} className="docter-link-form">
//                         {formError && (
//                             <p className="text-sm text-red-700 error-msge">
//                                 Debe llenar al menos un campo
//                             </p>
//                         )}
//                         {error !== '' && (
//                             <div className="mb-8 bg-blue-100 border-t-4 border-blue-500 rounded-b text-blue-900 px-4 py-3 shadow-md">
//                                 <div className="flex">
//                                     <div className="py-1">
//                                         <svg
//                                             className="fill-current h-6 w-6 text-blue-500 mr-4"
//                                             xmlns="http://www.w3.org/2000/svg"
//                                             viewBox="0 0 20 20"
//                                         >
//                                             <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
//                                         </svg>
//                                     </div>
//                                     <div>
//                                         <p className="font-bold mb-4">{error}</p>
//                                         <Link
//                                             to="/sign-in"
//                                             className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
//                                         >
//                                             Inicia sesión
//                                         </Link>
//                                     </div>
//                                 </div>
//                             </div>
//                         )}
//                         <div className="form-field-box-main w-90">
//                             <div className="field-1 form-field-box z-30">
//                                 <FormInputField
//                                     label="Nombre del Doctor"
//                                     type="text"
//                                     name="buscar"
//                                     id="buscar"
//                                     placeholder=""
//                                     registration={register('doctorName')}
//                                 />
//                             </div>

//                             <div
//                                 className="field-1 form-field-box !z-[99]"
//                                 onClick={handleSpecialtyClick}
//                                 style={{ cursor: 'pointer' }}
//                             >
//                                 {specialities.length > 0 ? (
//                                     <Controller
//                                         control={control}
//                                         name="specialty"
//                                         render={({ field }) => (
//                                             <>
//                                                 <label className="block mb-1 font-medium">Seleccione Especialidad</label>
//                                                 <Select
//                                                     ref={specialtyRef}
//                                                     options={specialities}
//                                                     isSearchable
//                                                     value={specialities.find(
//                                                         (option) => option.label === field.value || option.value === field.value
//                                                     )}
//                                                     onChange={(value) => field.onChange(value.label)}
//                                                     placeholder="Seleccione..."
//                                                     styles={customStyles}

//                                                 />
//                                             </>
//                                         )}
//                                     />
//                                 ) : (
//                                     <p>Loading specialties...</p>
//                                 )}
//                             </div>
//                             <div
//                                 className="field-1 form-field-box z-30"
//                                 onClick={handleInsuranceClick}
//                                 style={{ cursor: 'pointer' }}
//                             >
//                                 {insurances.length > 0 ? (
//                                     <Controller
//                                         control={control}
//                                         name="insurance"
//                                         render={({ field }) => (
//                                             <div>
//                                                 <label className="block mb-1 font-medium">Seleccione seguro compañía</label>
//                                                 <Select
//                                                     ref={insuranceRefs}
//                                                     options={insurances}
//                                                     isSearchable
//                                                     value={insurances.find(
//                                                         (option) => option.label === field.value || option.value === field.value
//                                                     )}
//                                                     onChange={(value) => field.onChange(value.label)}
//                                                     placeholder="Seleccione..."
//                                                     styles={customStyles}

//                                                 />
//                                             </div>
//                                         )}
//                                     />
//                                 ) : (
//                                     <p>Loading seguro... </p>
//                                 )}
//                             </div>

//                             <div className="field-2 form-field-box">
//                                 <Controller
//                                     control={control}
//                                     name="city"
//                                     render={({ field }) => (
//                                         <FormComboBox
//                                             label="Ciudad"
//                                             data={cities}
//                                             value={field.value}
//                                             onChange={(value) => field.onChange(value)}
//                                         />
//                                     )}
//                                 />
//                             </div>

//                             <div className="field-3 form-field-box">
//                                 <Controller
//                                     control={control}
//                                     name="date"
//                                     render={({ field }) => (
//                                         <FormDatePicker
//                                             identifier="date"
//                                             label="Fecha"
//                                             datePickerProps={{
//                                                 selected: field.value,
//                                                 dateFormat: 'dd/MM/yyyy',
//                                                 onChange: (date) => field.onChange(date),
//                                                 minDate: MIN_DATE,
//                                                 peekNextMonth: true,
//                                                 showMonthDropdown: true,
//                                                 showYearDropdown: false,
//                                                 dropdownMode: 'select'
//                                             }}
//                                         />
//                                     )}
//                                 />
//                             </div>

//                             <div className="search-btn-box">
//                                 <button type="submit" className="submit-btn">
//                                     <div>
//                                         <img
//                                             className="h-8 w-auto mr-1.5 flex justify-center"
//                                             src={imgsearch}
//                                             alt="DoctoLink"
//                                         />
//                                     </div>
//                                     Buscar
//                                 </button>
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </div>
//         </div>
//     );
// }



import { useRef } from 'react';
import { Controller } from 'react-hook-form';
import useSearch from '../hooks/useSearch';
import FormInputField from '../../common/components/formElements/FormInputField';
import SpecialitySubspecialitySelect from '../../common/components/formElements/SpecialitySubspecialitySelect';
import { Link, useSearchParams } from 'react-router-dom';
import imgsearch from './../../images/serch-icon.png';
import { useEffect, useState } from 'react';
import Select from 'react-select';

import axios from 'axios';

const auxDate = new Date();
const MIN_DATE = new Date(auxDate.setDate(auxDate.getDate() + 1));
const API_BASE_URL = process.env.REACT_APP_API_SERVER;

export default function Search() {
    const insuranceRefs = useRef(null);
    const dateInputRef = useRef(null);
    const [searchParams] = useSearchParams();
    const { onSearch, register, handleSubmit, control, formError, cities, error, reset, watch, setValue } =
        useSearch();
    const [specialities, setSpecialities] = useState([]);
    const [insurances, setInsurances] = useState([]);
    const selectedSpecialties = watch('specialty') || [];
    const selectedSecondarySpecialties = watch('secondarySpecialty') || [];

    const handleInsuranceClick = () => {
        if (insuranceRefs.current) {
            insuranceRefs.current.focus();
        }
    };

    useEffect(() => {
        const doctorNameParam = searchParams.get('doctorName') || '';
        const cityParam = searchParams.get('city');
        const dateParam = searchParams.get('date');
        const insuranceParam = searchParams.get('insurance');
        const specialityParam = searchParams.get('speciality');
        const secondarySpecialityParam = searchParams.get('secondarySpeciality');

        const selectedCity = cities.find((item) => item?.id?.toString() === cityParam) || null;
        const selectedInsurance = insuranceParam
            ? insurances.find((item) => insuranceParam.split(',').includes(item.label)) || null
            : null;
        const selectedSpecialities = specialityParam
            ? specialities.filter((item) => specialityParam.split(',').includes(item.value.toString()))
            : [];

        const selectedSecondarySpecialities = secondarySpecialityParam
            ? specialities
                  .flatMap((speciality) =>
                      (speciality.secondarySpecialties || []).map((secondary) => ({
                          value: secondary.id,
                          label: secondary.name,
                          specialtyId: speciality.value,
                          specialtyLabel: speciality.label
                      }))
                  )
                  .filter((item) => secondarySpecialityParam.split(',').includes(item.value.toString()))
            : [];

        setValue('doctorName', doctorNameParam);
        setValue('city', selectedCity);
        setValue('date', dateParam ? new Date(dateParam) : null);
        setValue('insurance', selectedInsurance);
        setValue('specialty', selectedSpecialities);
        setValue('secondarySpecialty', selectedSecondarySpecialities);
    }, [searchParams, cities, specialities, insurances, setValue]);

    // Optional: Agar future mein results page se aane pe pre-fill karna ho to alag logic laga sakte ho
    // Abhi ke liye intentionally blank rakha hai

    const getData = async () => {
        try {
            const [specialtyRes, insuranceRes] = await Promise.allSettled([
                axios.get(`${API_BASE_URL}/specialty/get-with-secondary`),
                axios.get(`${API_BASE_URL}/insurance/getList`)
            ]);

            if (specialtyRes.status === 'fulfilled') {
                const formattedSpecialties = specialtyRes.value.data
                    .map((item) => ({
                        value: item.id,
                        label: item.name,
                        secondarySpecialties: item.secondarySpecialties || []
                    }))
                    .sort((a, b) => {
                        // Normalize and compare case-insensitively for Spanish
                        const labelA = a.label.toLowerCase().trim();
                        const labelB = b.label.toLowerCase().trim();
                        return labelA.localeCompare(labelB, 'es', {
                            sensitivity: 'base',
                            numeric: true,
                            ignorePunctuation: true
                        });
                    });
                setSpecialities(formattedSpecialties);
            }

            if (insuranceRes.status === 'fulfilled') {
                const formattedInsurance = insuranceRes.value.data
                    .map((item) => ({
                        value: item.id,
                        label: item.name
                    }))
                    .sort((a, b) => {
                        // Normalize and compare case-insensitively for Spanish
                        const labelA = a.label.toLowerCase().trim();
                        const labelB = b.label.toLowerCase().trim();
                        return labelA.localeCompare(labelB, 'es', {
                            sensitivity: 'base',
                            numeric: true,
                            ignorePunctuation: true
                        });
                    });
                setInsurances(formattedInsurance);
            }
        } catch (error) {
            console.error('Unexpected error:', error);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const customStyles = {
        control: (styles) => ({
            ...styles,
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
            outline: 'none',
            borderRadius: '8px',
            '&:hover': { border: 'none' }
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            let backgroundColor = 'white';
            let color = 'black';

            if (isDisabled) {
                backgroundColor = '#f0f0f0';
                color = '#999';
            } else if (isSelected) {
                backgroundColor = '#3182ce';
                color = 'white';
            } else if (isFocused) {
                backgroundColor = '#ebf8ff';
                color = '#2b6cb0';
            }

            return {
                ...styles,
                backgroundColor,
                color,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                paddingLeft: data?.optionType === 'child' ? 28 : 12,
                fontSize: data?.optionType === 'child' ? 14 : 15
            };
        },
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (styles) => ({
            ...styles,
            color: '#888'
        }),
        menu: (styles) => ({
            ...styles,
            zIndex: 9999
        }),
        menuPortal: (styles) => ({
            ...styles,
            zIndex: 9999
        }),
        multiValue: (styles) => ({
            ...styles,
            backgroundColor: '#e8f2ff',
            borderRadius: 9999,
            maxWidth: 170
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            color: '#1e4f8f',
            fontWeight: 500,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
        })
    };

    const onSubmit = (data) => {
        onSearch(data);
    };

    const onClearFilters = () => {
        reset({
            doctorName: '',
            specialty: [],
            secondarySpecialty: [],
            insurance: null,
            city: null,
            date: null
        });
    };

    return (
        <div className="bg-dl-screen-lightblue lg:px-8 mx-auto px-4 relative sm:px-6">
            <div className="grid grid-cols-12 gap-12">
                <div className="col-span-12 md:col-span-12 search-box-top-main">
                    <form onSubmit={handleSubmit(onSubmit)} className="docter-link-form">
                        {formError && <p className="text-sm text-red-700 error-msge">Debe llenar al menos un campo</p>}
                        {error !== '' && (
                            <div className="mb-8 bg-blue-100 border-t-4 border-blue-500 rounded-b text-blue-900 px-4 py-3 shadow-md">
                                <div className="flex">
                                    <div className="py-1">
                                        <svg
                                            className="fill-current h-6 w-6 text-blue-500 mr-4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                        >
                                            <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="font-bold mb-4">{error}</p>
                                        <Link
                                            to="/sign-in"
                                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                                        >
                                            Inicia sesión
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="form-field-box-main w-90">
                            <div className="field-1 form-field-box z-30">
                                <FormInputField
                                    label="Nombre del Doctor"
                                    type="text"
                                    name="buscar"
                                    id="buscar"
                                    placeholder=""
                                    registration={register('doctorName')}
                                />
                            </div>

                            <div className="field-1 form-field-box !z-[99]">
                                <SpecialitySubspecialitySelect
                                    label="Seleccione Especialidad"
                                    specialities={specialities}
                                    selectedSpecialities={selectedSpecialties}
                                    selectedSubSpecialities={selectedSecondarySpecialties}
                                    onChange={({ selectedSpecialities, selectedSubSpecialities }) => {
                                        setValue('specialty', selectedSpecialities);
                                        setValue('secondarySpecialty', selectedSubSpecialities);
                                    }}
                                />
                            </div>

                            <div
                                className="field-1 form-field-box z-30"
                                onClick={handleInsuranceClick}
                                style={{ cursor: 'pointer' }}
                            >
                                {insurances.length > 0 ? (
                                    <Controller
                                        control={control}
                                        name="insurance"
                                        render={({ field }) => (
                                            <div>
                                                <label className="block mb-1 font-medium">
                                                    Seleccione seguro compañía
                                                </label>
                                                <Select
                                                    ref={insuranceRefs}
                                                    options={insurances}
                                                    isSearchable
                                                    value={field.value || null}
                                                    onChange={(option) => field.onChange(option || null)}
                                                    menuPortalTarget={document.body}
                                                    menuPosition="fixed"
                                                    placeholder="Seleccione..."
                                                    styles={customStyles}
                                                />
                                            </div>
                                        )}
                                    />
                                ) : (
                                    <p>Loading seguro... </p>
                                )}
                            </div>

                            <div className="field-2 form-field-box z-30">
                                <Controller
                                    control={control}
                                    name="city"
                                    render={({ field }) => (
                                        <>
                                            <label className="block mb-1 font-medium">Ciudad</label>
                                            <Select
                                                options={cities}
                                                isSearchable
                                                value={
                                                    cities.find(
                                                        (option) =>
                                                            option?.value === field.value?.value ||
                                                            option?.label === field.value?.label ||
                                                            (field.value?.id != null &&
                                                                option?.id?.toString() ===
                                                                    field.value?.id?.toString())
                                                    ) || null
                                                }
                                                onChange={(option) => field.onChange(option)}
                                                placeholder="Seleccione..."
                                                styles={customStyles}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                openMenuOnClick={true}
                                                openMenuOnFocus={true}
                                            />
                                        </>
                                    )}
                                />
                            </div>

                            <div className="field-3 form-field-box">
                                <Controller
                                    control={control}
                                    name="date"
                                    render={({ field }) => {
                                        // Convert Date object to YYYY-MM-DD format for native input
                                        const formatDateForInput = (date) => {
                                            if (!date) return '';
                                            const d = new Date(date);
                                            const year = d.getFullYear();
                                            const month = String(d.getMonth() + 1).padStart(2, '0');
                                            const day = String(d.getDate()).padStart(2, '0');
                                            return `${year}-${month}-${day}`;
                                        };

                                        // Convert YYYY-MM-DD string to Date object
                                        const parseInputDate = (dateString) => {
                                            if (!dateString) return null;
                                            return new Date(dateString);
                                        };

                                        return (
                                            <div className="w-full">
                                                <label htmlFor="date" className="block text-sm font-medium mb-1">
                                                    Fecha
                                                </label>
                                                <input
                                                    ref={dateInputRef}
                                                    type="date"
                                                    id="date"
                                                    value={formatDateForInput(field.value)}
                                                    onChange={(e) => field.onChange(parseInputDate(e.target.value))}
                                                    min={formatDateForInput(MIN_DATE)}
                                                    onClick={() => {
                                                        if (dateInputRef.current?.showPicker) {
                                                            dateInputRef.current.showPicker();
                                                        }
                                                    }}
                                                    onFocus={() => {
                                                        if (dateInputRef.current?.showPicker) {
                                                            dateInputRef.current.showPicker();
                                                        }
                                                    }}
                                                    onKeyDown={(e) => {
                                                        // Block ALL keyboard input - no typing allowed
                                                        // Only allow Tab for navigation
                                                        if (e.key !== 'Tab') {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    onPaste={(e) => e.preventDefault()}
                                                    onContextMenu={(e) => e.preventDefault()}
                                                    className="mt-1 block w-full max-w-full border border-gray-300 rounded-full shadow-sm py-2 px-3 focus:outline-none focus:ring-dl-primary-700 focus:border-dl-primary-700 sm:text-sm cursor-pointer box-border"
                                                    style={{ boxSizing: 'border-box' }}
                                                />
                                            </div>
                                        );
                                    }}
                                />
                            </div>

                            <div className="search-btn-box relative">
                                <button type="submit" className="submit-btn">
                                    <div>
                                        <img
                                            className="h-8 w-auto mr-1.5 flex justify-center"
                                            src={imgsearch}
                                            alt="DoctoLink"
                                        />
                                    </div>
                                    Buscar
                                </button>
                                <button
                                    type="button"
                                    onClick={onClearFilters}
                                    className="absolute -bottom-7 left-1/2 -translate-x-1/2 whitespace-nowrap text-sm font-semibold text-dl-primary-700 underline"
                                >
                                    Limpiar filtros
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
